module.exports = __webpack_public_path__ + "img/Shiokko_Profile_4.13ca8137.png";